/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
import SummaryTab from 'Components/SummaryTab/SummaryTab';
import EvaluationContent from 'Containers/Teleconsult/Main/FinishConsult/Review/Evaluation/EvaluationContent';
import { CircleGauge, FileText } from 'lucide-react';
import { parse } from 'marked';
import AttachmentsView from 'Modules/AttachmentsView/AttachmentsView';
import moment from 'moment';
import { func, objectOf, shape } from 'prop-types';
import { Modal, Segment } from 'semantic-ui-react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import styles from '../MessageBot.less';

const NoteContent = ({
  title,
  clinicalNotes,
  summary,
  plan,
  followUpDate,
  privateNote,
  attachments,
}) => (
  <>
    <div className={styles.item}>
      <div className={styles.title}>Title</div>
      <div className={styles.description}>{title}</div>
    </div>
    <div className={styles.item}>
      <div className={styles.title}>Clinical Notes</div>
      <div className={styles.description}>
        <div dangerouslySetInnerHTML={{ __html: parse(clinicalNotes ?? '') }} />
      </div>
    </div>
    <div className={styles.item}>
      <div className={styles.title}>Diagnosis</div>
      <div className={styles.description}>{summary}</div>
    </div>
    <div className={styles.item}>
      <div className={styles.title}>Plan</div>
      <div className={styles.description}>
        <div dangerouslySetInnerHTML={{ __html: parse(plan ?? '') }} />
      </div>
    </div>
    <div className={styles.item}>
      <div className={styles.title}>Follow up visit</div>
      <div className={styles.description}>
        {followUpDate ? moment(followUpDate).format('MMM DD, YYYY') : 'N/A'}
      </div>
    </div>
    <div className={styles.item}>
      <div className={styles.title}>Note</div>
      <div className={styles.description}>{privateNote || 'N/A'}</div>
    </div>
    <div className={styles.item}>
      <div className={styles.title} />
      <AttachmentsView attachments={attachments ?? []} />
    </div>
  </>
);

const ModalHealthSummary = props => {
  const { onClose, healthSummary } = props;

  const {
    data: { enableAiChecker },
  } = useSelector(state => state.webChat.doctor);

  const items = useMemo(
    () => [
      {
        key: '1',
        label: 'Notes',
        children: (
          <div className={styles.modalTab}>
            {healthSummary && (
              <NoteContent
                title={healthSummary.title}
                clinicalNotes={healthSummary.clinicalNotes}
                summary={healthSummary.summary}
                plan={healthSummary.plan}
                followUpDate={healthSummary.followUpDate}
                privateNote={healthSummary.privateNote}
                attachments={healthSummary.attachments}
              />
            )}
          </div>
        ),
        icon: <FileText size={16} />,
      },
      {
        key: '2',
        label: 'AI Checker’s Evaluation',
        children: (
          <div className={styles.modalTab}>
            <EvaluationContent evaluation={healthSummary?.evaluation} />
          </div>
        ),
        icon: <CircleGauge size={16} />,
      },
    ],
    [healthSummary],
  );

  return (
    <Modal open size="tiny" closeIcon onClose={onClose}>
      <Modal.Header>Consult Summary</Modal.Header>
      <Modal.Content as={Segment} basic style={{ minHeight: 300 }}>
        {enableAiChecker ? (
          <SummaryTab items={items} style={{ marginTop: -24 }} />
        ) : (
          <NoteContent
            title={healthSummary?.title}
            clinicalNotes={healthSummary?.clinicalNotes}
            summary={healthSummary?.summary}
            plan={healthSummary?.plan}
            followUpDate={healthSummary?.followUpDate}
            privateNote={healthSummary?.privateNote}
            attachments={healthSummary?.attachments}
          />
        )}
      </Modal.Content>
    </Modal>
  );
};

ModalHealthSummary.propTypes = {
  healthSummary: objectOf(shape({})).isRequired,
  onClose: func.isRequired,
};
ModalHealthSummary.defaultProps = {};

export default ModalHealthSummary;
